export default __webpack_public_path__ + "4065903416d676639a2bf9b8177a4ba0.png";